//@vendor
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../actions/mortgageAssociatedInsurances');

const setInitialState = () => Immutable.fromJS({
    isFetching: false,
    error: false,
    success: false,
    mortgageAssociatedInsurances: []
});

const mortgageAssociatedInsurancesReducer = handleActions(
    {
        [simpleActions.mortgageAssociatedInsurances]: state =>
            state.merge({
                isFetching: true,
                error: false,
                success: false
            }),
        [simpleActions.mortgageAssociatedInsurancesSuccess]: (state, action) =>
            state.merge({
                isFetching: false,
                error: false,
                success: true,
                mortgageAssociatedInsurances: action.payload.data
            }),
        [simpleActions.mortgageAssociatedInsurancesError]: (state, action) =>
            state.merge({
                isFetching: false,
                error: action.payload.error,
                success: false,
                mortgageAssociatedInsurances: []
            })
    },
    setInitialState()
);

module.exports = mortgageAssociatedInsurancesReducer;
module.exports.setInitialState = setInitialState;
